import React from "react";

function ImageIcon({ width = "20px", height = "20px", color = "#7030A0" }) {
  return (
    <svg
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 370.32 370.32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M320.816,63.219L261.94,4.339C259.156,1.561,255.391,0,251.457,0H74.272 
        C58.219,0,45.16,13.06,45.16,29.112v312.095c0,16.053,13.059,29.113,29.111,29.113h221.777
        c16.053,0,29.111-13.06,29.111-29.113V73.703C325.16,69.769,323.6,65.997,320.816,63.219z
        M230.861,32.414v43.577c0,10.554,8.555,19.106,19.105,19.106h43.58v198.025l-23.623-33.956
        c-5.554-7.983-14.589-12.832-24.312-13.046c-9.732-0.23-18.964,4.231-24.864,11.961l-15.667,20.525l-35.676-59.11
        c-5.496-9.107-15.35-14.684-25.987-14.708c-0.023,0-0.046,0-0.069,0c-10.611,0-20.459,5.527-25.984,14.589
        l-40.591,66.564V32.414H230.861z"
        fill={color}
      />
      <circle cx="203.953" cy="148.329" r="25" fill={color} />
    </svg>
  );
}

export default ImageIcon;
